import { EventEmitter } from "fbemitter";

export const AppEvent = {
    NavigateToProjectStep: 'onNavigateToProjectStep',
    UpdateThisProject: 'onUpdateThisProject',
    CheckDependencies: 'onCheckDependencies',
    DisplayFloorPlanDialog: 'onDisplayFloorPlanDialog'
};

export default new EventEmitter();